import { memo } from 'react';

import { Breadcrumbs, type BreadcrumbsItemType } from '@air/component-breadcrumbs';

export type PublicBoardTopBarAncestorsProps = {
  /**
   * The fully-built breadcrumb trail. This component is a DUMB renderer: it owns only the Breadcrumbs
   * presentation (compact threshold, size, visible-at-end) and knows nothing about where the items
   * came from. The board area supplies board-only items (PublicBoardTopbarBreadcrumbs); the collection
   * area supplies the {Collection} / {Sub-page} / {…ancestors} / {Board} trail
   * (PublicShowcaseBoardBreadcrumbs). Neither the collection nor the sub-page read lives here — that
   * is what keeps this shared board leaf free of collection logic (FOUND-7: one tree per route,
   * composition over "am I in a collection?" checks).
   */
  items: BreadcrumbsItemType[];
};

export const PublicBoardTopBarAncestors = memo(({ items }: PublicBoardTopBarAncestorsProps) => {
  return (
    <Breadcrumbs
      data-testid="PUBLIC_BOARD_TOPBAR_ANCESTORS"
      isCompact={items.length > 4}
      items={items}
      size="small"
      visibleItemsAtEnd={2}
    />
  );
});

PublicBoardTopBarAncestors.displayName = 'PublicBoardTopBarAncestors';
